/* VMB: Algolia autocomplete on the Tinker theme – header search icon on the /search page.
   The Algolia app mounts autocomplete on ONE form only (the first visible match of
   form[action="/search"], re-evaluated on window resize). On the search results page the
   page's own search form comes first in the DOM and is always visible, so the header modal
   never gets Algolia and falls back to the theme's native predictive search ("Recently viewed").
   Fix: on that page, the header search icon focuses the page's Algolia search box instead of
   opening the modal. Everywhere else the modal keeps working as usual. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[on\\:click="#search-modal/showDialog"]');
    if (!btn) return;
    var pageInput = document.querySelector('form.search-page-input__parent .aa-Input, form.search-page-input__parent input[type="search"]');
    if (!pageInput) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    pageInput.scrollIntoView({ block: 'center', behavior: 'smooth' });
    pageInput.focus();
    if (pageInput.select) pageInput.select();
  }, true);
})();
